/** Minute-precision campaign timer. No app, network calls or moving digits. */
class TfpCampaignCountdown extends HTMLElement {
  static observedAttributes = ['data-deadline'];
  #timer;
  #controller;

  connectedCallback() {
    this.#controller?.abort();
    this.#controller = new AbortController();
    document.addEventListener('visibilitychange', this.update, { signal: this.#controller.signal });
    this.update();
  }

  disconnectedCallback() {
    clearTimeout(this.#timer);
    this.#controller?.abort();
  }

  attributeChangedCallback() {
    if (this.isConnected && this.#controller) this.update();
  }

  update = () => {
    clearTimeout(this.#timer);
    const value = this.dataset.deadline || '';
    const valid = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(?::\d{2}(?:\.\d{1,3})?)?(?:Z|[+-]\d{2}:\d{2})$/.test(value);
    const end = valid ? Date.parse(value) : NaN;
    const remaining = end - Date.now();
    if (!Number.isFinite(remaining) || remaining <= 0) {
      this.hidden = true;
      const meta = this.closest('[data-campaign-meta]');
      if (meta && !meta.querySelector('[data-campaign-meta-copy]')) {
        meta.hidden = true;
        meta.dataset.countdownExpired = 'true';
        const layout = meta.closest('.tfp-campaign-banner__banner');
        layout?.classList.add('tfp-campaign-banner__banner--no-offer');
        if (layout && !layout.querySelector('.tfp-campaign-banner__banner-copy, .tfp-campaign-banner__banner-cta')) {
          const banner = layout.closest('[data-campaign-banner]');
          if (banner) { banner.hidden = true; banner.dataset.countdownExpired = 'true'; }
        }
      }
      return;
    }
    this.hidden = false;
    const meta = this.closest('[data-campaign-meta]');
    if (meta?.dataset.countdownExpired) {
      meta.hidden = false;
      delete meta.dataset.countdownExpired;
      meta.closest('.tfp-campaign-banner__banner')?.classList.remove('tfp-campaign-banner__banner--no-offer');
    }
    const banner = this.closest('[data-campaign-banner]');
    if (banner?.dataset.countdownExpired) { banner.hidden = false; delete banner.dataset.countdownExpired; }
    const minutes = Math.ceil(remaining / 60000);
    const values = { days: Math.floor(minutes / 1440), hours: Math.floor(minutes % 1440 / 60), minutes: minutes % 60 };
    for (const [unit, number] of Object.entries(values)) {
      const target = this.querySelector(`[data-countdown-${unit}]`);
      const text = String(number).padStart(2, '0');
      if (target && target.textContent !== text) target.textContent = text;
    }
    if (!document.hidden) {
      const delay = Math.min(remaining, (remaining % 60000 || 60000) + 20);
      this.#timer = setTimeout(this.update, delay);
    }
  };
}

if (!customElements.get('tfp-campaign-countdown')) customElements.define('tfp-campaign-countdown', TfpCampaignCountdown);
